import { ConversationAction } from '../actions/conversationActions';
import { FeatureAction } from '../actions/featureActions';
import { GptConfigurationsAction } from '../actions/gptConfigurationsAction';
import { QuotaAction } from '../actions/quotaActions';
import { RootStateAction } from '../actions/rootStateActions';
import { SurveyAction } from '../actions/surveyAction';
import { ThemeAction } from '../actions/themeActions';
import { UserPreferencesAction } from '../actions/userPreferencesAction';
import { RootState } from '../models/rootState';
import { conversationsReducer } from './conversationsReducer';
import { featureFlagsReducer } from './featureFlagsReducer';
import { gptConfigurationsReducer } from './gptConfigurationsReducer';
import { quotaReducer } from './quotaReducer';
import { surveyReducer } from './surveyReducer';
import { themeReducer } from './themeReducer';
import { userPreferencesReducer } from './userPreferencesReducer';

export const rootReducer = (state: RootState, action: RootStateAction): RootState => {
    const conversationAction = action as ConversationAction;
    
    return {
        chats: conversationsReducer(state.chats, conversationAction),
        conversationsCursor: conversationAction.type === 'SET_CONVERSATIONS' 
            ? conversationAction.cursor 
            : conversationAction.type === 'SET_CONVERSATIONS_CURSOR'
            ? conversationAction.payload
            : conversationAction.type === 'CLEAR_CONVERSATIONS'
            ? undefined
            : state.conversationsCursor,
        quota: quotaReducer(state.quota, action as QuotaAction),
        theme: themeReducer(state.theme, action as ThemeAction),
        features: featureFlagsReducer(state.features, action as FeatureAction),
        userPreferences: userPreferencesReducer(state.userPreferences, action as UserPreferencesAction),
        gptConfigurations: gptConfigurationsReducer(state.gptConfigurations, action as GptConfigurationsAction),
        survey: surveyReducer(state.survey, action as SurveyAction),
    };
};

export default rootReducer;
